import { clsx } from "clsx";
import { useState } from "react";

import { useGlobalKeyboardShortcut } from "@smart/itops-hooks-dom";
import { Button } from "@smart/itops-sb-design-system-dom";

import { MatterDebug } from "./matter";
import { UserDebug } from "./user";

const Debug = () => {
  const [enabled, setEnabled] = useState(false);
  const [visible, setVisible] = useState(false);
  useGlobalKeyboardShortcut({
    key: "F12",
    modifiers: { shift: true, ctrlOrMeta: true },
    fn: () => setEnabled((current) => !current),
  });

  if (!enabled) return null;

  return (
    <div
      className={clsx(
        "w-[40rem] h-[60rem] p-[1.5rem] bg-white border border-neutral-100 rounded fixed bottom-0",
        visible ? "right-0" : "right-[-40rem]",
      )}
    >
      <Button
        className={clsx(
          "absolute bottom-[5rem] right-[100%]",
          visible ? "translate-x-[50%]" : "translate-x-[20%]",
        )}
        leftIcon={visible ? "regularArrowRight" : "regularArrowLeft"}
        variant="secondaryDefault"
        onClick={() => setVisible((current) => !current)}
      />
      <UserDebug />
      <MatterDebug />
    </div>
  );
};

export { Debug };
